import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import FeaturesSelector, { AVAILABLE_FEATURES } from './FeaturesSelector';
import { 
  ModalHeader, 
  ModalHeaderContent, 
  ModalIcon, 
  ModalTitle, 
  ModalSubtitle,
  ModalBody,
  ModalFooter,
  SecondaryButton,
  PrimaryButton
} from './styles';
import { withTranslation } from 'react-i18next';
import { ShieldIcon } from '../../images/svgIcons';
import { ADD_ORG_DIALOG, FEATURES } from './translationValues';

const NAMESPACES = [];

function FeaturesModal({ t, open, onOpenChange, organization, onSave }) {
  const [features, setFeatures] = useState(organization?.features || AVAILABLE_FEATURES);

  useEffect(() => {
  if (organization) {
    const orgFeatures = organization.features || [];

    const initializedFeatures = AVAILABLE_FEATURES.map(f => ({
      ...f,
      isEnabled:
        orgFeatures.length > 0
          ? orgFeatures.some(of => of.name === f.name && of.isEnabled)
          : true
    }));

    setFeatures(initializedFeatures);
  }
}, [organization]);


  const handleSave = () => {
    onSave({organizationId: organization.id, data: features, isJsonConfig: true, configType: 'features'});
    onOpenChange(false);
  };

  const handleCancel = () => {
    const orgFeatures = organization?.features || [];
    const resetFeatures = AVAILABLE_FEATURES.map(f => ({
      ...f,
      isEnabled:
        orgFeatures.length > 0
          ? orgFeatures.some(of => of.name === f.name && of.isEnabled)
          : true
    }));

    setFeatures(resetFeatures);
    onOpenChange(false);
  };

  if (!organization) return null;

  return (
    <Modal
      visible={open}
      onCancel={handleCancel}
      footer={null}
      width={900}
      bodyStyle={{ padding: 0 }}
      style={{ top: '30px' }}
      closable={false}
    >
      <ModalHeader style={{ borderRadius: '8px 8px 0 0' }}>
        <ModalHeaderContent>
          <ModalIcon>
            <ShieldIcon />
          </ModalIcon>
          <div>
            <ModalTitle>{t(FEATURES.MANAGE_FEATURES.key, FEATURES.MANAGE_FEATURES.value)}</ModalTitle>
            <ModalSubtitle>{organization.name}</ModalSubtitle>
          </div>
        </ModalHeaderContent>
      </ModalHeader>

      <ModalBody>
        <FeaturesSelector
          features={features}
          isDisabled={organization.status==='inactive'}
          onChange={setFeatures}
        />
      </ModalBody>

      <ModalFooter style={{ borderRadius: '0 0 8px 8px' }}>
        <SecondaryButton onClick={handleCancel}>
          {t(ADD_ORG_DIALOG.CANCEL_LABEL.key, ADD_ORG_DIALOG.CANCEL_LABEL.value)}
        </SecondaryButton>
        <PrimaryButton onClick={handleSave} style={organization.status==='inactive' ? {flex: 1, opacity: 0.3, cursor: 'not-allowed'}: {flex: 1}} disabled={organization.status==='inactive'} >
          {t(FEATURES.SAVE_FEATURES.key, FEATURES.SAVE_FEATURES.value)}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
}

export default withTranslation(NAMESPACES)(FeaturesModal);
